import { Clock, MapPin } from "lucide-react";

const ServiceTimesBar = () => {
  const services = [
    { day: "Sunday", time: "8:00 AM", name: "Leadership Training" },
    { day: "Sunday", time: "11:00 AM", name: "Worship Encounter" },
    { day: "Wednesday", time: "7:00 PM", name: "Bible Training" },
  ];

  return (
    <section className="service-bar" data-testid="service-times-bar">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
          {/* Service Times */}
          <div className="flex flex-col md:flex-row md:items-center gap-6 md:gap-12">
            <div className="flex items-center gap-2">
              <Clock size={20} className="text-[#FFB800]" />
              <span className="text-overline text-white/60">Service Times</span>
            </div>
            <div className="flex flex-col md:flex-row gap-4 md:gap-8">
              {services.map((service, index) => (
                <div key={index} className="flex items-center gap-3" data-testid={`service-time-${index}`}>
                  <span className="font-['Satoshi'] font-bold text-white">
                    {service.day} {service.time}
                  </span>
                  <span className="text-white/50">|</span>
                  <span className="font-['Satoshi'] text-white/80">
                    {service.name}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Location */}
          <div className="flex items-center gap-2">
            <MapPin size={20} className="text-[#FFB800]" />
            <span className="font-['Satoshi'] text-white/80">
              8900 Hayne Boulevard, New Orleans, LA
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceTimesBar;
